module.exports = __webpack_public_path__ + "static/media/importICS1.1cdfbb66.png";